import React, {Component, createRef} from 'react';
import gsap from "gsap";
import './Scene6.css';
import esports from '../../Resources/esports.jpg';
import headphones from '../../Resources/headphones.png'
import MaxButton from "../MaxButton";
import {FormattedMessage} from "react-intl";
import {ch, cw} from "../../Utilities/utils";
import BgGrid from "../BgGrid";
import {MenuIcons} from "../menu/MenuIcons";

const scene6 = createRef();

class Scene6 extends Component<> {
    constructor(props) {
        super(props);
        this.line1 = createRef();
        this.line2 = createRef();
        this.underlined1 = createRef();
        this.underlined2 = createRef();
        this.container = createRef();
    }

    componentDidMount() {
        let line1Top = ch(this.underlined1, this.container);
        let line2Top = ch(this.underlined2, this.container);

        gsap.timeline({
            scrollTrigger: {
                trigger: scene6.current,
                start: 'top top',
                end: '+=120%',
                scrub: true,
                pin: '#scene6',
                toggleActions: 'play complete restart reverse',
            }
        }).from(scene6.current, {
            duration: 0.01,
            zIndex: 0,
        }).from('#s6bg' , {
            opacity: 0,
            duration: 0.04,
        }, '0')
        .fromTo('#s4bg',{
            opacity: 1,
        },{
            duration: 0.04,
            opacity: 0,
        }, '0')
        .from(".s6-esports", {
            opacity: 0.8,
            y: "40vh",
            clipPath: 'inset(60vh 0 0 0)',
            duration: 4,
            ease: "power2.easeIn"
        }).to(".s6-esports", {
            ease: "power3.easeInOut",
            opacity: 1,
            y: "-100vh",
            duration: 7,
        }, "+=2")
        .from('.s6-headphones', {
            x: "100vw",
            duration: 4,
            opacity: 1,
            transform: "matrix(0.9, 0.45, -0.45, 0.9, 0, 0)",
        }, "1")
        .to('.s6-headphones', {
            ease: "power2.easeIn",
            y: "85vh",
            duration: 3,
            opacity: 1,
            transform: "rotate(-52deg)",
        }, "7")
        .to('.s6-headphones', {
            opacity: 0,
            duration: 0.2,
        }, "9.8")
        .from('.s6-text', {
            opacity: 0.5,
            x: "-105%",
            stagger: .2,
            repeat: 1,
            repeatDelay: 3,
            yoyo: true,
            duration: 2.5,
        }, "1")
        .fromTo(this.line1.current, {
            opacity: 0,
            width: 0,
            top: line1Top,
        },{
            opacity: 1,
            width: cw(this.underlined1, this.container),
            top: line1Top,
            stagger: .3,
            repeat: 1,
            repeatDelay: 3,
            yoyo: true,
            duration: 1.5,
        }, "2")
        .fromTo(this.line2.current, {
            opacity: 0,
            width: 0,
            top: line2Top,
        },{
            width: cw(this.underlined2, this.container),
            top: line2Top,
            opacity: 1,
            stagger: .3,
            repeat: 1,
            repeatDelay: 3,
            yoyo: true,
            duration: 1.5,
        }, "2");
    }

    render() {

        return (
            <section ref={scene6} className={"s6-container bg4"}>
                <div id="scene6" className={"content"}>
                    <div className={'s6-images-container'}>
                        <img src={esports} className={"s6-esports accessibility-img"} alt={'eSports'}/>
                    </div>
                    <BgGrid id='s6bg' hLines={6}
                        shapes={[{id: 's6gc', shape: '+', x:6, y:1, size:6, color:"gold"},
                                 {id: 's6rc', shape: '+', x:3, y:4, size:6, color:"red"},
                                ]} />
                    <img src={headphones} className={"s6-headphones"} alt={'headphones'}/>
                    <div ref={this.line1} className={'underline orange left accessibility-line'}/>
                    <div ref={this.line2} className={'underline orange left accessibility-line'}/>
                    <div className={'s6-text-container clip-all'} ref={this.container} >
                        <h2><span className={'s6-text accessibility-font'}>
                            <FormattedMessage id={"home_esports_title"}/>
                        </span></h2>
                        <h1>
                            <span className={"s6-text"}><FormattedMessage id={"home_esports_txt"}/></span>
                            <span className={"s6-text"}><FormattedMessage id={"home_esports_txt_2"}/></span>
                            <span className={"s6-text"}><FormattedMessage id={"home_esports_txt_3"}/></span>
                            <span className={"s6-text"} ref={this.underlined1} >
                                <FormattedMessage id={"home_esports_txt_4"}/>
                            </span>
                            <span className={"s6-text"} ref={this.underlined2} >
                                <FormattedMessage id={"home_esports_txt_5"}/>
                            </span>
                        </h1>
                        <div className={'s6-text'}>
                            <MaxButton clickRoute={'services/esports'}>
                                home_learn_more_button
                            </MaxButton>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Scene6;
